<template>
  <div
      v-if="incident"
      class="fields-container"
      v-bind:style="{ height: height + 'px' }"
  >
    <template v-if="hasNonGenericFields">
      <component
          v-bind:is="categorySlug"
          :incident-data="incident.data"
      ></component>
    </template>
    <template v-for="(field, index) in fieldList">
      <v-row v-bind:key="'field_' + index ">
        <v-col
          sm="6"
          class="text-right"
        >
          <span class="field-name">{{ field.name }}</span>
        </v-col>
        <v-col
          sm="6"
          class="text-left"
        >
          <span v-if="typeof field.field === 'string' && !field.values">
            {{ incident.data[field.field] || '-' }}
          </span>
          <span v-if="typeof field.field === 'string' && field.values">
            {{ incident.data[field.field]
              ? getFieldValue(field, incident.data[field.field])
              : '-' }}
          </span>
          <span v-if="typeof field.field === 'object' && field.type === 'datetime'">
            {{ incident.data[field.field[0]] && incident.data[field.field[1]]
              ? incident.data[field.field[0]] + ' ' + incident.data[field.field[1]]
              : '-' }}
          </span>
          <span
            v-if="typeof field.field === 'object'
                      && (field.type === 'integer-pn'
                        || field.type === 'dbp-pn'
                        )"
            >
            {{ formatValue(incident.data[field.field[0]]) }}
            <span style="color: red">{{ incident.data[field.field[1]]
              ? ' (PN: ' + getPnFieldValue(field, incident.data[field.field[1]]) + ')'
                : '' }}</span>
          </span>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import TherapiesFields from '@/components/IncidentView/ViewNonGenericFields/TherapiesFields';

export default {
  name: 'ViewCategoryFields',
  components: {
    therapies: TherapiesFields,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
    fieldList: {
      type: Array,
      required: true,
    },
    incident: {
      type: Object,
    },
    categorySlug: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    hasNonGenericFields() {
      return Object.prototype.hasOwnProperty.call(
        this.$options.components,
        this.categorySlug,
      );
    },
  },
  methods: {
    formatValue(value) {
      if (value === null || value === '') return '-';
      return value;
    },
    getFieldValue(field, value) {
      if (Object.prototype.hasOwnProperty.call(field.values, value)) {
        return (field.displayValue ? `${value} - ` : '') + field.values[value];
      }
      return value;
    },
    getPnFieldValue(field, value) {
      if (Object.prototype.hasOwnProperty.call(field.pnValues, value)) {
        return field.pnValues[value];
      }
      return value;
    },
  },
};
</script>

<style lang="scss">
.fields-container {
  overflow-y: scroll;
  overflow-x: hidden;
  .field-name {
    color: #9a9a9a;
  }
}
</style>
